module.exports = __webpack_public_path__ + "img/n8.d500fb46.svg";